import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import dompurify from "isomorphic-dompurify";
import { useTranslations } from "@jti/ui";
import useSubscriptionBillingDate from "../../../hooks/useSubscriptionBillingDate";
import { SubscriptionBenefits } from "../SubscriptionBenefits/SubscriptionBenefits";
import { SubscriptionPrices } from "../SubscriptionPrices/SubscriptionPrices";
import styles from "./SummarySubscriptionFooter.module.scss";
const { sanitize } = dompurify;
export const SummarySubscriptionFooter = ({ displayPointsSection = true }) => {
    const { __ } = useTranslations();
    const billingDate = useSubscriptionBillingDate();
    const billingDateText = billingDate
        ? __("summarySubscription.nextBilling", [billingDate])
        : __("summarySubscription.nextBillingError");
    return (_jsxs(_Fragment, { children: [_jsx(SubscriptionBenefits, {}), _jsxs("div", { className: classNames(styles.section, styles.sectionPrices), children: [_jsx(SubscriptionPrices, {}), _jsx("div", { children: _jsx("p", { className: styles.smallText, dangerouslySetInnerHTML: {
                                __html: sanitize(billingDateText),
                            } }) })] }), displayPointsSection && (_jsx("div", { className: classNames(styles.section, styles.sectionPoints), "data-testid": "subscription-summary-points", children: _jsx("p", { className: styles.smallText, children: __("summarySubscription.collectPoints", [0]) }) }))] }));
};
//# sourceMappingURL=SummarySubscriptionFooter.js.map